import React from "react";
import { Form, Col, Input } from "antd";
import AutoCompleteAddress from "../views/FirstMile/CrediteBooking/AutoCompleteAddress";
import AutoSelectAndType from "../views/FirstMile/CrediteBooking/AutoSelectAndType";
import { preventTextPaste } from "../utils";

export const ReciverAddressComponent = ({
  form,
  reviverNameAndAddress,
  parseInt,
  span = 6,
  handleOnEnter,
  resetForm,
  bookType,
  disabledFeilds,
}) => {
  return (
    <>
      <Col lg={6} sm={6}>
        <AutoSelectAndType
          form={form}
          // fieldName="receiverName"
          bookType={bookType}
          disabledFeilds={disabledFeilds}
          reviverNameAndAddress={reviverNameAndAddress?.receiverDetails}
        />
      </Col>
      <Col lg={span} sm={span}>
        <AutoCompleteAddress
          handleOnEnter={handleOnEnter}
          disabledFeilds={disabledFeilds}
          form={form}
          resetForm={resetForm}
          addressDetailsCallback={null}
          fieldName="receiverAddress"
          label="Receiver Address"
          rules={[
            {
              required: true,
              message: "Enter receiver address",
            },
          ]}
        />
      </Col>
      <Col span={6}>
        <Form.Item
          label="Mobile number"
          name="mobileNumber"
          rules={[
            {
              required: true,
              message: "Enter mobile number",
            },
            () => ({
              validator(rule, value = "") {
                if (value.length > 0 && value.length < 10) {
                  return Promise.reject("Enter 10 digits number");
                } else if (parseInt(value.substring(1, 0)) === 0) {
                  return Promise.reject("Mobile number should not be 0");
                } else {
                  return Promise.resolve();
                }
              },
            }),
          ]}
          onKeyPress={(e) => {
            if (e.key == "Enter") {
              handleOnEnter(e);
            } else if (/[^0-9]/.test(e.key)) {
              e.preventDefault();
            }
          }}
        >
          <Input
            disabled={disabledFeilds}
            placeholder="Enter phone number"
            maxLength={10}
            onInput={(e) => preventTextPaste(e, 10)}
            type="number"
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          label="Email address"
          name="receiverEmail"
          onKeyPress={(e) => {
            if (e.key == "Enter") {
              handleOnEnter(e);
            }
          }}
          rules={[
            {
              type: "email",
              message: "Give the correct email",
            },
          ]}
        >
          <Input
            maxLength={40}
            disabled={disabledFeilds}
            placeholder="Enter email address"
            onBlur={(e) =>
              form.setFieldValue(
                "returnEmail",
                e.target.value.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      </Col>
    </>
  );
};
